import Header from "./header"
import List from "./list"
import styles from "./style.module.scss";

const MainComponent = ({list = []}) => {
  return (
      <div className={styles.tabsContainer}>
        <Header />
        <List list={list} />
      </div>
  );
};


export default MainComponent;
